export default __webpack_public_path__ + "static/media/TiTa_Load.51e3f2b0.gif";